import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLeads from "@/pages/admin/AdminLeads";

export const Route = createFileRoute("/admin/leads/")({
  head: () => pageHead("Admin \u2014 Leads \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLeads,
});
